import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import '../../styles/Product.scss';

export default function Psu() {
  const [psuList, setPsuList] = useState([]);

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await fetch(
          'https://sheets.googleapis.com/v4/spreadsheets/1usVfJ-1O_wRD5fcLxVQVfskcSQ-L6hmDp2kvFckvGO8/values/Лист1!A:F?key=AIzaSyAbLqcy6h2MPUSuWJh93fUax3NIAUPtgv8'
        );
        const data = await res.json();

        const rows = data.values;
        if (!rows || rows.length < 2) return;

        const headers = rows[0];
        const items = rows.slice(1).map((row) => {
          const obj = {};
          headers.forEach((h, i) => (obj[h.trim().toLowerCase()] = row[i] || ''));
          return obj;
        });

        // фильтруем только те, где категория = psu
        const psuItems = items.filter(
          (item) => item.category?.trim().toLowerCase() === 'psu'
        );

        setPsuList(psuItems);
      } catch (err) {
        console.error('Ошибка при загрузке данных:', err);
      }
    }

    fetchData();
  }, []);

  return (
    <div className="psu">
      <h1>Блоки питания</h1>
      <div className="psu__list">
        {psuList.length > 0 ? (
          psuList.map((psu) => (
            <div key={psu.id} className="psu__card">
              <img src={psu.image} alt={psu.name} />
              <h2>{psu.name}</h2>
              <p className="specs">{psu.description}</p>
              <p className="price">{psu.price}</p>
              <Link to={`/components/psu/${psu.id}`} className="btn">
                Подробнее
              </Link>
            </div>
          ))
        ) : (
          <p>Загрузка...</p>
        )}
      </div>
    </div>
  );
}
